import { createAsyncThunk } from '@reduxjs/toolkit';
import type { SvpAssetId } from '@vgtv/api-client/lib/svp_asset';

import favouritesApi from '../../services/favouritesApi';
import { selectAssetById } from '../assets';
import { config } from '../../config';
import { fetchSvpAssetsByIds } from '../assets/actions';
import { fetchAllCategories } from '../categories/actions';
import type { RootState } from '../store';

export const fetchFavourites = createAsyncThunk(
  'favourites/get',
  async (_, thunkAPI) => {
    const data = await favouritesApi.favourites.getFavourites();

    const favouriteAssetIds = data.entities
      .filter((entity) => entity.type === 'asset')
      .map((entity) => entity.entity_id as SvpAssetId)
      .filter(
        (id) =>
          !selectAssetById(
            thunkAPI.getState() as RootState,
            config.provider,
            id
          )
      );

    Promise.all([
      favouriteAssetIds.length > 0
        ? await thunkAPI
            .dispatch(
              fetchSvpAssetsByIds({
                assetsIds: favouriteAssetIds,
                vendor: config.provider,
                limit: 100,
              })
            )
            .unwrap()
        : '',
      await thunkAPI.dispatch(fetchAllCategories(config.provider)).unwrap(),
    ]).catch(() => null);
    return data;
  }
);

export const addToFavourites = createAsyncThunk(
  'favourites/add',
  async (id: `${string}:${number}`) => {
    return favouritesApi.favourites.addToFavourites(id);
  }
);

export const removeFromFavourites = createAsyncThunk(
  'favourites/remove',
  async (id: `${string}:${number}`) => {
    return favouritesApi.favourites.removeFromFavourites(id);
  }
);
